// extracted by mini-css-extract-plugin
export default {"column":"RowColumn_column__TD5j1"};